
/*
 * https://developerx.atlassian.net/browse/CS-4941
 * https://developerx.atlassian.net/browse/CS-4948
 *
 * Created at : 08 Feb 2022           Updated at : 08 Feb 2022
 * Created by : Risman Abdilah        Updated by : Risman Abdilah
 *
 * Version 2.3.0
 */

import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

interface OrganizationFormType {
  id: number;
  role: string;
  organization: string;
  description: string;
  is_current: boolean;
  since: string;
  until: string | null;
}

@Component
export default class ModalOrganization extends Vue {
  /* VUEX */
  /* ACTION */

  /* PROP */
  @Prop({ default: false })
  private isShow: boolean;
  @Prop({ default: null })
  private organization: any;

  /* STATE */

  @Watch("isShow", { deep: true, immediate: true })
  private listenModal(showModal: boolean) {
    if (showModal) {
      if (this.organization) {
        this.isEdit = true;
        this.organizationForm = this.organization;
      } else {
        this.isEdit = false;
        this.organizationForm = {
          id: 0,
          role: "",
          organization: "",
          description: "",
          is_current: false,
          since: "",
          until: null,
        };
      }
    }
  }

  /* INITIALIZATION */
  private isEdit = false;
  private organizationForm: OrganizationFormType = {
    id: 0,
    role: "",
    organization: "",
    description: "",
    is_current: false,
    since: "",
    until: null,
  };

  /* METHODS */

  private onSubmit() {
    this.$emit("update:isShow", false);
  }
}
